export const ROUTE_MAIN = '/';
export const ROUTE_MAIN_CREATE_ANSWER_DEPARTMENT = '/answer/department';
export const ROUTE_MAIN_CREATE_ANSWER_AUTHOR = '/answer/author';
export const ROUTE_MAIN_CREATE_ANSWER_CLIENT = '/answer/client';
export const ROUTE_MAIN_CREATE_ANSWER_PAYMENT = '/answer/payment';
export const ROUTE_MAIN_CREATE_ANSWER_FEEDBACK = '/answer/feedback';
export const ROUTE_MAIN_CREATE_FEEDBACK_SUCCESS = '/answer/feedback-success';
export const ROUTE_MAIN_CARD = '/card';
export const ROUTE_MAIN_CARD_CREATED = '/card/success-created';
export const ROUTE_MAIN_CARD_REFILLED = '/card/success-refilled';
export const ROUTE_MAIN_CARD_PAYED = '/card/success-payed';
export const ROUTE_MAIN_CREATE_ANSWER = '/answer';
export const ROUTE_MAIN_CREATE_LETTER = '/letter';
export const ROUTE_MAIN_CREATE_LETTER_RECEIVER = '/letter/receiver';
export const ROUTE_MAIN_CREATE_ANSWER_RECEIVER = '/answer/receiver';
export const ROUTE_MAIN_CREATE_LETTER_DEPARTMENT = '/letter/department';
export const ROUTE_MAIN_CREATE_LETTER_CLIENT = '/letter/client';
export const ROUTE_MAIN_CREATE_LETTER_TEXT = '/letter/text';
export const ROUTE_MAIN_CREATE_LETTER_PAYMENT = '/letter/payment';
export const ROUTE_MAIN_CREATE_LETTER_AUTHOR = '/letter/author';
export const ROUTE_MAIN_CREATE_LETTER_SUCCESS = '/letter/success';
export const ROUTE_AUTHENTICATION = '/sign-in';
export const ROUTE_AUTHENTICATION_LOCKED = '/sign-in/locked';
export const ROUTE_REGISTRATION = '/sign-up';
export const ROUTE_REGISTRATION_CONFIRM_REQUEST = '/sign-up/request';
export const ROUTE_REGISTRATION_CONFIRM_SUCCESS = '/sign-up/confirm';
export const ROUTE_REGISTRATION_SUCCESS = '/sign-up/success';
export const ROUTE_RESTORE = '/restore';
export const ROUTE_RESTORE_NEW = '/restore/new';
export const ROUTE_RESTORE_SUCCESS = '/restore/success';
export const ROUTE_PROFILE = '/profile';
export const ROUTE_CHANGE_EMAIL = '/change-email';
export const ROUTE_ABOUT = '/about';
export const ROUTE_HELP = '/help';
export const ROUTE_OFFER = '/offer';
export const ROUTE_COOKIE_CONSENT = '/cookie-consent';
export const ROUTE_HELP_WORK = '/help/work';
export const ROUTE_HELP_FAQ = '/help/faq';
export const ROUTE_HELP_REGIONS = '/help/regions';
export const ROUTE_HELP_REGIONS_ID = '/help/regions/:regId';
export const ROUTE_HELP_REGIONS_CHAR = '/help/regions/mobile';
export const ROUTE_HELP_DEPARTMENT = '/help/regions/:regId/:depId';
export const ROUTE_HELP_FEEDBACK = '/help/feedback';
export const ROUTE_HELP_FEEDBACK_NUMBER = '/help/feedback/:number';
export const ROUTE_INBOX = '/inbox';
export const ROUTE_INBOX_LETTER = '/inbox/letters/:id';
export const ROUTE_OUTBOX = '/outbox';
export const ROUTE_OUTBOX_LETTER = '/outbox/letters/:id';
export const ROUTE_DRAFTS = '/drafts';
export const ROUTE_CREATE = '/create';
export const ROUTE_CREATE_LETTER = '/create/letter';
export const ROUTE_CREATE_ANSWER = '/create/answer';
export const ROUTE_CREATE_REPLY = '/create/reply';
export const ROUTE_CREATE_LETTER_DEPARTMENT = '/create/letter/department';
export const ROUTE_CREATE_LETTER_CLIENT = '/create/letter/client';
export const ROUTE_CREATE_LETTER_TEXT = '/create/letter/text';
export const ROUTE_CREATE_LETTER_PAYMENT = '/create/letter/payment';
export const ROUTE_CREATE_LETTER_AUTHOR = '/create/letter/author';
export const ROUTE_CREATE_LETTER_SUCCESS = '/create/letter/success';
export const ROUTE_CREATE_REPLY_LETTER = '/create/reply/letter';
export const ROUTE_CREATE_REPLY_LETTER_ID = '/create/reply/letter/:id';
export const ROUTE_CREATE_ANSWER_DEPARTMENT = '/create/answer/department';
export const ROUTE_CREATE_ANSWER_SENDER = '/create/answer/sender';
export const ROUTE_CREATE_ANSWER_PAYMENT = '/create/answer/payment';
export const ROUTE_CREATE_REPLY_ANSWER = '/create/reply/answer';
export const ROUTE_CREATE_ANSWER_FEEDBACK = '/create/answer/feedback';
export const ROUTE_CREATE_FEEDBACK_SUCCESS = '/create/answer/feedback-success';
export const ROUTE_CHECK_LETTER_STATUS = '/info/check';
export const ROUTE_LETTER_PHOTO_STATUS = '/letter/photo-status';
export const ROUTE_REDIRECT = '/redirect';
export const ROUTE_REDIRECT_LETTER = '/redirect/letter';
export const ROUTE_REDIRECT_DEPARTMENT = '/redirect/department';
export const ROUTE_REDIRECT_SUCCESS = '/redirect/success';
export const ROUTE_VIEW_INITIATIVE = '/initiative';
export const ROUTE_PAYMENT_INITIATIVE = '/initiative/payment/:uuid';
export const ROUTE_PAYMENT_INITIATIVE_SUCCESS = '/initiative/payment/success/:uuid';
export const ROUTE_ERROR = '/error';
export const ROUTE_ERROR_LETTER_PAYED = '/error/letter-payed';
export const ROUTE_ERROR_CARD_REFILL = '/error/card-refill';
export const ROUTE_ERROR_CARD_PAYED = '/error/card-payed';

export const getInboxLetterRoute = (letterId: number): string => {
  return ROUTE_INBOX_LETTER.replace(':id', String(letterId));
};

export const getCreateLetterReplyRoute = (letterId: number): string => {
  return ROUTE_CREATE_REPLY_LETTER_ID.replace(':id', String(letterId));
};

export const getOutboxLetterRoute = (letterId: number): string => {
  return ROUTE_OUTBOX_LETTER.replace(':id', String(letterId));
};

export const getHelpDepartmentsRoute = (regId: number, depId: number): string => {
  return ROUTE_HELP_DEPARTMENT.replace(':regId', String(regId)).replace(':depId', String(depId));
};

export const getHelpRegionRoute = (regionId: number): string => {
  return ROUTE_HELP_REGIONS_ID.replace(':regId', String(regionId));
};

export const getHelpFeedbackRoute = (letterNumber: number): string => {
  return ROUTE_HELP_FEEDBACK_NUMBER.replace(':number', String(letterNumber));
};

export const getInitiativeLetterPaymentRoute = (uuid: string): string => {
  return ROUTE_PAYMENT_INITIATIVE.replace(':uuid', uuid);
};

export const getRegistrationConfirmRequestRoute = (email: string): string => {
  return ROUTE_REGISTRATION_CONFIRM_REQUEST + `?email=${email}`;
};

/**
 * Identifier of the FAQ entry about binding a phone number.
 * The FAQ is addressed by identifier rather than by position,
 * because the older `?scroll=N` links name an ordinal and inserting an entry silently re-aims them.
 */
export const FAQ_QUESTION_PHONE_BINDING = 'phone-binding';

/**
 * Builds a link that opens the FAQ with one entry already expanded and scrolled into view.
 *
 * @param question The entry identifier, such as `FAQ_QUESTION_PHONE_BINDING`.
 */
export const getHelpFaqQuestionRoute = (question: string): string => {
  return `${ROUTE_HELP_FAQ}?question=${encodeURIComponent(question)}`;
};
